// extracted by mini-css-extract-plugin
export default {"overall-sentiment":"overall-sentiment_overall-sentiment__YN7y7"};